"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var PrismCss_1 = __importDefault(require("./PrismCss"));
var reconnect_js_1 = require("reconnect.js");
function RevCodeArea(props) {
  var schema = props.schema,
    _a = props.value,
    value = _a === void 0 ? '' : _a,
    onChange = props.onChange;
  var codeElemRef = react_1.default.useRef(null);
  var _b = react_1.default.useState(true),
    hide = _b[0],
    setHide = _b[1];
  var _c = react_1.default.useState((schema === null || schema === void 0 ? void 0 : schema.lang) || 'javascript'),
    lang = _c[0],
    setLang = _c[1];
  react_1.default.useEffect(function () {
    if (!codeElemRef.current) {
      return;
    }
    var Prism = window.Prism;
    if (!Prism) {
      return;
    }
    var html = Prism.highlight(value, Prism.languages[lang], lang);
    codeElemRef.current.innerHTML = html;
  }, [value, lang]);
  return react_1.default.createElement(Wrapper, null, react_1.default.createElement("div", {
    className: 'collapse' + (hide ? ' hide ' : '')
  }, react_1.default.createElement("div", {
    className: "icon",
    style: {
      color: value ? 'blue' : '#888'
    },
    onClick: function onClick() {
      if (value) {
        setHide(function (prev) {
          return !prev;
        });
      }
    }
  }, "\u25B6"), react_1.default.createElement("div", {
    className: "langs"
  }, ['javascript', 'html', 'css', 'python'].filter(function (l) {
    if (!(schema === null || schema === void 0 ? void 0 : schema.lang)) {
      return true;
    }
    return l === (schema === null || schema === void 0 ? void 0 : schema.lang);
  }).map(function (l) {
    var selected = lang === l;
    return react_1.default.createElement("div", {
      key: l,
      style: {
        color: selected ? 'black' : '#888'
      },
      onClick: function onClick() {
        if (!(schema === null || schema === void 0 ? void 0 : schema.lang)) {
          setLang(l);
        }
      }
    }, l);
  }))), react_1.default.createElement("pre", {
    "aria-hidden": true,
    className: 'highlighting' + (hide ? ' hide ' : '') + (!value ? 'empty' : ''),
    onClick: function onClick() {
      reconnect_js_1.getOutlet('CodeEditorModal').update({
        lang: lang,
        value: value,
        updateValue: onChange
      });
    }
  }, !value ? react_1.default.createElement("span", null, "\u7121") : hide ? react_1.default.createElement("span", null, "...") : null, react_1.default.createElement("code", {
    className: "language-" + lang,
    ref: codeElemRef
  })));
}
exports.default = RevCodeArea;
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  & > .collapse {\n    cursor: pointer;\n    background-color: #d9d9d9;\n    border: solid 1px #d9d9d9;\n    padding: 2px 11px;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      opacity: 0.75;\n    }\n  }\n\n  & > .collapse > .icon {\n    display: inline-block;\n    color: #707070;\n    transition: transform 0.1s ease-in;\n    transform: rotate(90deg);\n  }\n\n  & > .collapse > .langs {\n    display: flex;\n    align-items: center;\n\n    & > * {\n      margin: 0px 20px;\n    }\n  }\n\n  & > .collapse.hide > div {\n    transform: rotate(0deg);\n  }\n\n  & > .highlighting {\n    background-color: #fff;\n    border: #d9d9d9;\n    padding: 4px 11px;\n    width: 100%;\n    overflow: auto;\n    transition: all 0.2s ease-in;\n    cursor: pointer;\n    &:hover {\n      opacity: 0.75;\n    }\n  }\n\n  & > .highlighting,\n  & > .highlighting * {\n    font-size: 12px;\n    font-family: monospace;\n    line-height: 16px;\n    margin: 0;\n  }\n\n  & > .highlighting.hide > code {\n    opacity: 0;\n    height: 0;\n    display: block;\n  }\n\n  & > .highlighting.empty {\n    background-color: #ddd;\n    border: dashed 1px #999;\n    color: #999;\n  }\n"], ["\n  ", "\n\n  & > .collapse {\n    cursor: pointer;\n    background-color: #d9d9d9;\n    border: solid 1px #d9d9d9;\n    padding: 2px 11px;\n    display: flex;\n    align-items: center;\n\n    &:hover {\n      opacity: 0.75;\n    }\n  }\n\n  & > .collapse > .icon {\n    display: inline-block;\n    color: #707070;\n    transition: transform 0.1s ease-in;\n    transform: rotate(90deg);\n  }\n\n  & > .collapse > .langs {\n    display: flex;\n    align-items: center;\n\n    & > * {\n      margin: 0px 20px;\n    }\n  }\n\n  & > .collapse.hide > div {\n    transform: rotate(0deg);\n  }\n\n  & > .highlighting {\n    background-color: #fff;\n    border: #d9d9d9;\n    padding: 4px 11px;\n    width: 100%;\n    overflow: auto;\n    transition: all 0.2s ease-in;\n    cursor: pointer;\n    &:hover {\n      opacity: 0.75;\n    }\n  }\n\n  & > .highlighting,\n  & > .highlighting * {\n    font-size: 12px;\n    font-family: monospace;\n    line-height: 16px;\n    margin: 0;\n  }\n\n  & > .highlighting.hide > code {\n    opacity: 0;\n    height: 0;\n    display: block;\n  }\n\n  & > .highlighting.empty {\n    background-color: #ddd;\n    border: dashed 1px #999;\n    color: #999;\n  }\n"])), PrismCss_1.default);
var templateObject_1;